import React from 'react';
import { Facebook, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-zinc-950 text-zinc-400 py-12" data-id="element-9">
      <div className="container max-w-screen-2xl" data-id="element-10">
        <div className="grid md:grid-cols-4 gap-8 mb-8" data-id="element-11">
          <div className="md:col-span-2" data-id="element-12">
            <img src="https://cdn.magicpatterns.com/uploads/n9D75188rNsFCRtFuBjbv5/hauser-logo.webp" alt="Hauser's Complete Care" className="h-12 object-contain mb-6 brightness-0 invert opacity-80" data-id="element-13" />
            <p className="max-w-xs mb-6" data-id="element-14">
              Reliable, high-quality landscaping and snow plowing services for
              residential and commercial properties.
            </p>
            <div className="flex gap-3" data-id="element-15">
              <a href="https://www.facebook.com/hauserscompletecareinc" target="_blank" rel="noopener noreferrer" aria-label="Visit us on Facebook" className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-zinc-800 text-zinc-300 hover:bg-primary hover:text-primary-foreground transition-colors" data-id="element-16">
                <Facebook className="h-5 w-5" data-id="element-17" />
              </a>
              <a href="https://maps.app.goo.gl/RHx11FTgfNUyLUbi9" target="_blank" rel="noopener noreferrer" aria-label="View us on Google Maps" className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-zinc-800 text-zinc-300 hover:bg-primary hover:text-primary-foreground transition-colors" data-id="element-18">
                <MapPin className="h-5 w-5" data-id="element-19" />
              </a>
            </div>
          </div>

          <div data-id="element-20">
            <h4 className="text-white font-bold mb-4" data-id="element-21">Services</h4>
            <ul className="space-y-2 text-sm" data-id="element-22">
              {['Landscape Installation & Design', 'Lawn Care & Maintenance', 'Sod & Seeding', 'Snowplowing', 'Hardscaping', 'Spring & Fall Clean Up'].map(s => <li key={s} data-id="element-23">
                  <a href="#services" className="hover:text-white transition-colors" data-id="element-24">
                    {s}
                  </a>
                </li>)}
            </ul>
          </div>

          <div data-id="element-25">
            <h4 className="text-white font-bold mb-4" data-id="element-26">Service Area</h4>
            <ul className="space-y-2 text-sm" data-id="element-27">
              <li data-id="element-28">Lancaster, NY</li>
              <li data-id="element-29">Depew, NY</li>
              <li data-id="element-30">Cheektowaga, NY</li>
              <li data-id="element-31">West Seneca, NY</li>
              <li data-id="element-32">Williamsville, NY</li>
              <li data-id="element-33">Amherst, NY</li>
              <li data-id="element-34">Clarence, NY</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-zinc-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm" data-id="element-35">
          <p data-id="element-36">
            © {new Date().getFullYear()} Hauser's Complete Care Inc. All rights
            reserved.
          </p>
          <div className="flex gap-4" data-id="element-37">
            <a href="#" className="hover:text-white transition-colors" data-id="element-38">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-39">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}